import React, { useContext } from 'react';

import noop from 'lodash/noop';

import { Issue } from '@qality/common-model';

export interface ExportTestCaseFormat {
  'Issue Key': string;
  'Test case name': string;
  Description: string;
  'Test Step': string;
  'Test Result': string;
  'Test Data': string;
}

export type ExportOptions =
  | { source: 'url' }
  | {
      source: 'issues';
      issues: Array<Issue>;
    }
  | { source: 'jql'; jql: string };

export type ExportStatus =
  | 'default'
  | 'init'
  | 'fetchSteps'
  | 'error'
  | 'success'
  | 'noIssues'
  | 'makeFile';

export interface ExportTestCasesContextProps {
  numberOfExportedIssues: number;
  exportStatus: ExportStatus;
  exportTestCases: (options: ExportOptions) => Promise<void>;
}

export const initialValues: ExportTestCasesContextProps = {
  numberOfExportedIssues: 0,
  exportStatus: 'default',
  exportTestCases: (options: ExportOptions) => Promise.resolve(noop(options)),
};

export const ExportTestCasesContext =
  React.createContext<ExportTestCasesContextProps>(initialValues);

export const useExportTestCasesContext = (): ExportTestCasesContextProps => {
  return useContext(ExportTestCasesContext);
};
